export const colors = {
	main: 'RGBA(238, 155, 34, 1.00)',
	white: 'white',
	grisOscuro: 'RGBA(188, 188, 188, 1.00)',
	grisClaro: 'RGBA(188, 188, 188, 0.4)',
	black: 'RGBA(0,0,0,.84)',
	red: 'RGBA(183, 13, 27, 1.00)',
	clave: 'RGBA(0,0,0,.64)',
};



// WEBPACK FOOTER //
// ./src/utils/colors.js